import React, { Component } from 'react';
import { string, number, func, bool, oneOfType } from 'prop-types';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import UTModal from '../UTModal';
import { appConfig } from '../../../config/customization';
import UTTouchableWithoutFeedback from '../UTTouchableWithoutFeedback';
import { message } from '../../../utils/stringUtils';
import Images from '../../../config/assets';

import stylesJS from './styles';
import styles from './styles.module.scss';

class UTDownloadBill extends Component {
  state = { modalIsOpen: false };

  onConfirm = () => {
    this.setState({ modalIsOpen: false });
  };

  handleClick = event => {
    event.stopPropagation();
    if (appConfig.encodedDocumentDownload) {
      this.props.onClickDownload(this.props.billId);
    } else {
      this.props.onClickDownload(this.props.billId);
    }
  };

  handleCloseModal = () => this.setState({ modalIsOpen: false });

  render() {
    return (
      <div style={stylesJS.container}>
        {this.props.useIcon ? (
          [
            <UTTouchableWithoutFeedback key="download" onClick={!this.props.disabled && this.handleClick}>
              <img
                src={this.props.disabled ? Images.downloadBillDisabled : Images.downloadBill}
                style={stylesJS.downloadButton}
                alt=""
              />
            </UTTouchableWithoutFeedback>,
            this.props.labelButton && (
              <UTLabel small light style={stylesJS.labelButton}>
                {this.props.labelButton}
              </UTLabel>
            )
          ]
        ) : (
          <UTButton
            style={this.props.style}
            className={styles.button}
            disabled={this.props.disabled}
            onPress={this.handleClick}
          >
            {this.props.labelButton}
          </UTButton>
        )}
        <UTModal
          isOpen={this.state.modalIsOpen}
          onRequestClose={() => this.setState({ modalIsOpen: false })}
          title={this.props.title}
          acceptButton={{
            text: message('Commons:accept'),
            onPress: () => {
              this.onConfirm();
              window.open(this.props.downloadUrl);
            }
          }}
          cancelButton={{
            onPress: this.handleCloseModal,
            text: message('Commons:cancel')
          }}
        >
          <div style={stylesJS.containerPopup}>
            {this.props.downloadUrl && !this.props.loading ? (
              <div style={stylesJS.containerElements}>
                <div style={stylesJS.textContainer}>
                  {this.props.period && (
                    <div style={stylesJS.element}>
                      <UTLabel style={stylesJS.billDetail} semibold darkGray>
                        {message('Bills:period')}
                      </UTLabel>
                      <UTLabel semibold>{this.props.period}</UTLabel>
                    </div>
                  )}
                  {this.props.amount && (
                    <div style={stylesJS.element}>
                      <UTLabel style={stylesJS.billDetail} semibold darkGray>
                        {message('Bills:amount')}
                      </UTLabel>
                      <UTLabel semibold>{this.props.amount}</UTLabel>
                    </div>
                  )}
                </div>
                {!this.props.amount && !this.props.period && (
                  <UTLabel semibold style={stylesJS.textInputSize}>
                    {message('Bills:confirmDownloadMssg')}
                  </UTLabel>
                )}
              </div>
            ) : (
              this.props.loadingMessage && (
                <div style={stylesJS.containerElements}>
                  <UTLabel semibold style={stylesJS.textInputSize}>
                    {this.props.loadingMessage}
                  </UTLabel>
                </div>
              )
            )}
          </div>
        </UTModal>
      </div>
    );
  }
}

UTDownloadBill.propTypes = {
  loadingMessage: string,
  loading: bool,
  title: string,
  downloadUrl: string,
  onClickDownload: func.isRequired,
  billId: number,
  labelButton: oneOfType([string, bool]),
  period: string,
  amount: string,
  disabled: bool,
  useIcon: bool
};

export default Radium(UTDownloadBill);
